import * as React from "react"

import { cn } from "@/lib/utils"

const Logo = React.forwardRef(({ className, alt = "pycrop", ...props }, ref) => (
  <img
    ref={ref}
    src="/assets/app-logo/logo.png"
    alt={alt}
    className={cn("h-10 w-auto object-contain", className)}
    {...props} />
))
Logo.displayName = "Logo"

export default Logo
